import { Component } from '@theme/component';

class SecurProductInfo extends Component {
  #events;
  #animations = new Map();
  #motion;

  connectedCallback() {
    super.connectedCallback();
    this.#events?.abort();
    this.#events = new AbortController();
    this.#motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.addEventListener('click', this.#handleClick, { signal: this.#events.signal });
  }

  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const contact = event.target.closest('[data-sc-info-support]');
    if (contact) {
      const support = document.getElementById(contact.dataset.scInfoSupport);
      const trigger = support?.querySelector('[data-sc-support-open]');
      if (trigger instanceof HTMLElement) {
        event.preventDefault();
        trigger.click();
        const dialog = support.querySelector('dialog');
        if (dialog instanceof HTMLDialogElement && dialog.open) {
          dialog.addEventListener('close', () => contact.focus({ preventScroll: true }), { once: true, signal: this.#events.signal });
        }
      }
      return;
    }
    const summary = event.target.closest('.sc-info__item > summary');
    if (!summary || summary.closest('secur-product-info') !== this) return;
    const item = summary.parentElement;
    if (!(item instanceof HTMLDetailsElement)) return;
    event.preventDefault();
    const opening = !item.open || item.hasAttribute('data-sc-closing');
    if (opening) {
      this.querySelectorAll('.sc-info__item[open]').forEach((other) => {
        if (other !== item && !other.hasAttribute('data-sc-closing')) this.#toggle(other, false);
      });
    }
    this.#toggle(item, opening);
  };

  #toggle(item, opening) {
    const summary = item.querySelector('summary');
    const panel = item.querySelector('.sc-info__panel');
    if (!summary || !panel) return;
    const initialHeight = item.getBoundingClientRect().height;
    this.#animations.get(item)?.cancel();
    this.#animations.delete(item);
    item.toggleAttribute('data-sc-closing', !opening);
    item.open = true;
    if (this.#motion.matches || !item.animate) {
      item.open = opening;
      item.removeAttribute('data-sc-closing');
      item.style.overflow = '';
      return;
    }
    const borderHeight = item.getBoundingClientRect().height - item.clientHeight;
    const targetHeight = summary.getBoundingClientRect().height + borderHeight + (opening ? panel.getBoundingClientRect().height : 0);
    item.style.overflow = 'hidden';
    const animation = item.animate(
      [{ height: `${initialHeight}px` }, { height: `${targetHeight}px` }],
      { duration: 300, easing: 'cubic-bezier(.22,.68,0,1)', fill: 'none' }
    );
    this.#animations.set(item, animation);
    animation.onfinish = () => {
      if (this.#animations.get(item) !== animation) return;
      item.open = opening;
      item.removeAttribute('data-sc-closing');
      item.style.overflow = '';
      this.#animations.delete(item);
    };
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#events?.abort();
    for (const [item, animation] of this.#animations) {
      animation.cancel();
      if (item.hasAttribute('data-sc-closing')) item.open = false;
      item.removeAttribute('data-sc-closing');
      item.style.overflow = '';
    }
    this.#animations.clear();
  }
}

if (!customElements.get('secur-product-info')) customElements.define('secur-product-info', SecurProductInfo);
